import { isSuspended, onSuspend } from './suspension';

export type TimerOptions = {
    callback: (seconds: number) => unknown;
    end: number;
};

export type IntervalHandle = ReturnType<typeof setInterval>;

export const getCurrentTime = () => new Date().getTime();

export const createTimer = (
    dateMs: number,
    callback: (seconds: number) => unknown
) => {
    let id: IntervalHandle;
    let unsubscribe = () => {};

    const end = () => {
        clearInterval(id);
        unsubscribe();
    };

    const ticker = () => {
        if (isSuspended()) return;
        const seconds = Math.floor((dateMs - getCurrentTime()) / 1000);

        if (seconds <= 0) {
            end();
        }

        if (seconds < 0) {
            return;
        }

        callback(seconds);
    };

    id = setInterval(ticker, 1000);
    unsubscribe = onSuspend(end);
    ticker();

    return { id, end };
};
